import React from 'react'

import { useIsMobile } from '@/shared/hooks/useIsMobile'

interface DetailRowProps {
  /** 行标签 */
  label: string
  /** 值区域，自由内容（文本 / HashLink / ActionBadge / CopyButton 等） */
  children: React.ReactNode
  /** 最后一行隐藏移动端分隔线 */
  hideDivider?: boolean
}

/**
 * 标签-值展示行，用于交易/地址/区块详情页的 KV-list 展示。
 * 内部处理桌面/移动端响应式布局差异。
 *   - 桌面端：label 左侧 180px 固定宽度 + value 左侧对齐，gap 24px
 *   - 移动端：label 左侧 72px 固定宽度 + value 右侧对齐，border-bottom 分隔行
 */
const DetailRow: React.FC<DetailRowProps> = ({ label, children, hideDivider }) => {
  const isMobile = useIsMobile()

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: isMobile ? 'var(--space-md)' : 'var(--space-2xl)',
        padding: isMobile ? 'var(--space-10) var(--space-lg)' : 'var(--space-xl) 0',
        borderBottom: isMobile && !hideDivider ? '0.5px solid var(--app-hairline-subtle)' : 'none',
        marginBottom: !isMobile && !hideDivider ? 'var(--space-xs)' : '0',
      }}
    >
      <span
        style={{
          color: 'var(--app-text-secondary)',
          fontSize: isMobile ? 'var(--font-size-xs)' : 'var(--font-size-lg)',
          fontWeight: 600,
          flexShrink: 0,
          minWidth: isMobile ? 'var(--detail-row-label-mobile-width)' : 'var(--detail-row-label-desktop-width)',
          lineHeight: isMobile ? 'var(--line-height-md)' : 'var(--line-height-lg)',
        }}
      >
        {label}
      </span>
      <div
        style={
          isMobile
            ? { flex: 1, minWidth: 0, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }
            : { flex: 1, minWidth: 0, textAlign: 'left' }
        }
      >
        {children}
      </div>
    </div>
  )
}

export default DetailRow
